import { observer } from "mobx-react-lite";
import { FC } from "react";
import { PdfPageLimitWarningModalStore } from "@/components/modal/pdf-page-limit-warning/pdf-page-limit-warning-modal-store";
import {
  MDSButton,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import { MDSButtonGroup } from "@/mds/components/buttons/button-group";

export interface PdfPageLimitWarningModalProps {
  store: PdfPageLimitWarningModalStore;
}

export const PdfPageLimitWarningModal: FC<PdfPageLimitWarningModalProps> = observer(({ store }) => {
  return (
    <MDSModalDialog isOpen={store.isOpen} handleClose={() => store.cancel()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        This PDF is too long to fully understand
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphSm}>
          This document is {store.pageCount} pages. Mem will understand the first {store.pageLimit}{" "}
          pages and make them searchable and available in chat. Pages beyond that will still be
          attached but won&apos;t be searchable.
        </MDSText>
      </MDSDialogTextContent>
      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton variant={MDSButtonVariant.Default} onClick={() => store.cancel()}>
          Cancel
        </MDSButton>
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={() => store.confirm()}>
          Upload anyway
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
